import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetBoardsByCategoryIdResponse } from "../../api/board_category/_id@number/boards";

export type TApiGetBoardsByCategoryIdResult = {
  result?: GetBoardsByCategoryIdResponse;
};

export const fetchBoardsByCategoryId = async (category_id: number, limit: number, page: number): Promise<TApiResult & TApiGetBoardsByCategoryIdResult> => {
    const query = {
        query: { limit, page }
    }
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board_categories._id(category_id).boards().get({...query, ...authHeader})
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchBoardsByCategoryId");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
